module.exports = __webpack_public_path__ + "img/sigra.1cb4b2d3.png";